import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ category, categoryName, articleTitle, searchQuery }) => {
  return (
    <nav className="flex items-center gap-1.5 text-xs text-slate-400 flex-wrap" data-testid="breadcrumbs">
      <Link to="/" className="hover:text-slate-600 transition-colors flex items-center gap-1">
        <Home className="h-3 w-3" />
        Home
      </Link>
      <ChevronRight className="h-3 w-3" />
      <Link to="/academy" className="hover:text-slate-600 transition-colors">
        Academy
      </Link>

      {searchQuery !== undefined && (
        <>
          <ChevronRight className="h-3 w-3" />
          <span className="text-slate-600">Search</span>
        </>
      )}

      {category && (
        <>
          <ChevronRight className="h-3 w-3" />
          <Link to={`/academy/category/${category}`} className="hover:text-slate-600 transition-colors">
            {categoryName || category}
          </Link>
        </>
      )}

      {articleTitle && (
        <>
          <ChevronRight className="h-3 w-3" />
          <span className="text-slate-600 truncate max-w-[200px]">{articleTitle}</span>
        </>
      )}
    </nav>
  );
};

export default Breadcrumbs;
